export const 近三年经营情况字段 = ["net_asset1", "sales_revenue1", "total_profit1", "net_asset2", "sales_revenue2", "total_profit2", "net_asset3", "sales_revenue3", "total_profit3"]
export const 申报表主表所有万元金额字段 = [...近三年经营情况字段, "china_cost", "basics_cost", "enterprise_income"]
export const 上年度销售收入字段 = ["shr"]
export const 研究经费总预算字段 = ["spending"]
export const 研究经费近三年总支出字段 = ["zc1", "zc2", "zc3"]
export const 研发活动日期字段 = ["dataEprPQzsj", "dataEprPJssj"]
export const 授权日期 = ["txtDate"]
export const 企业填报人签字日期 = ["fillUserDate"]
export const 研究开发费用明细字段 = ["nbyjkftr", "ryrg", "zjtr", "zjfy", "wxzc", "sjf", "sbtsf", "qtfy", "wtwbyjkftr", "pjnwbtrhj", "nwhj"]
export const 研发职务工作内容 = [
    ['研发负责人', '负责项目统筹管理'],
    ['研发专员', '负责产品运营'],
    ['研发工程师', '负责技术方案设计，技术方案实施'],
    ['研发人员', '数据分析'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
    ['研发专员', '业务逻辑开发'],
]
export const 内部研究开发费用说明 = [
    ['ryrg', '人员人工费', '直接从事研发活动的本企业在职人员费用'],
    ['zjtr', '直接投入费用', '研发活动直接消耗的材料、燃料和动力费用'],
    ['zjfy', '折旧费用与长期待摊费用', '专门用于研发活动的相关设备的折旧费'],
    ['wxzc', '无形资产摊销费用', '软件、知识产权、非专利技术的摊销费用'],
    ['sjf', '设计费用', '进行构思、开发和制造，进行工序、技术规范等发生的费用'],
    ['sbtsf', '装备调试费用与试验费用', '专门用于中间实验和综合性能测试的样品费及各项送检费用'],
    ['qtfy', '其他费用', '与研发活动直接相关的其它费用'],
]
export const SERVER = "gqrd-gql.relay.ac.cn"
export const APIURL = 'https://' + SERVER
export const CDNURL = "http://gqrd-cdn.relay.ac.cn/"
export const authServer = 'https://auth.relay.ac.cn'
export const pdfApi = 'https://service-6l8fphk1-1259725782.sh.apigw.tencentcs.com/release/api/render'
export const 流程=['企业基本信息填写','企业基本信息填写完成','中介研发项目完成','财务信息填写完成','立项书生成完成','材料盖章上传完成','项目申报完成']
